export default "__VITE_ASSET__d9b975ae__"